import Ajax from 'js/utils/ajax/ajax';

export const approveInvoiceBatch = (invoiceBatchId) =>
  Ajax.patch(`/invoices/v1/invoicebatches/${invoiceBatchId}/approve`);

export const disapproveInvoiceBatch = (invoiceBatchId) =>
  Ajax.patch(`/invoices/v1/invoicebatches/${invoiceBatchId}/disapprove`);
